import cornerstone from 'cornerstone-core';
import { getCurrentStudy } from './studiesManager';
import store from '../store/store';

// export const getElementIncompleteLayout = (layoutElementIndex, numElements) => {
//   const { layout, statusLayout } = store.getState();
//   const { elements } = layout;
//   const { selectedViewIndex: previousIndex } = statusLayout;
//   let element;
//   const numTotalViews = layout.rows * layout.columns;
//   const step = Math.floor(numTotalViews / numElements);
//   let iteration = 0;
//   for (let i = 0; i < numTotalViews, element === undefined; i += step, iteration++) {
//     if (layoutElementIndex < i) {
//       if (previousIndex === undefined || previousIndex === 0 || iteration > numElements - 1) {
//         element = elements[iteration - 1].element;
//       } else {
//         element = elements[iteration].element;
//       }
//     }
//   }

//   return element;
// };

export const getStudy = (patient, StudyInstanceUID) => {
  // TODO: Throw error or something when not finding study
  const studyIndex = patient.studies.findIndex((el) => el.StudyInstanceUID === StudyInstanceUID);
  return studyIndex !== -1 ? patient.studies[studyIndex] : patient.studies[0];
};

export const getSeries = (study, SeriesInstanceUID) => {
  if (!study.series || study.series.length < 0) {
    return;
  }
  const seriesIndex = study.series.findIndex((serie) => serie.SeriesInstanceUID === SeriesInstanceUID);
  return study.series[seriesIndex] || study.series[0];
};

export const getWadoURI = (instances) => instances.map((instance) => instance.wadouri);
